// Stitches each dashboard gadget's resolved scope (held in a ref-backed registry,
// keyed by canvas card) onto the structural view, at the moment a question is
// sent — the scope half of what mergeValuesIntoView does for figures.
//
// A dashboard's structural view carries no view-level date range or filters (each
// gadget has its own), so this is where the agent actually learns what period and
// filters produced each gadget's numbers. Must run BEFORE mergeValuesIntoView,
// which strips the `cardId` join key.
//
// A no-op for reports: they register no gadget scopes, so scopesByCardId is empty
// and every gadget passes through untouched.

import {
  InsightsGadgetScopeFragment,
  InsightsView,
} from 'contextProviders/InsightsContentProvider/viewTypes';

const mergeScopeIntoView = ({
  view,
  scopesByCardId,
}: {
  view: InsightsView;
  scopesByCardId: { [cardId: string]: InsightsGadgetScopeFragment };
}): InsightsView => {
  // The view-level filters are empty on a dashboard, so a per-gadget filter the
  // agent can't reproduce is the only thing that can raise this flag — OR it in
  // rather than overwrite, so a structural signal (unreproducible trend, default
  // dataset filter) already set by the builder is preserved.
  let hasUnreproducibleFilters = view.hasUnreproducibleFilters;

  const gadgets = view.gadgets.map((gadget) => {
    const fragment = gadget.cardId ? scopesByCardId[gadget.cardId] : undefined;
    if (!fragment) {
      return gadget;
    }
    if (fragment.hasUnreproducibleFilters) {
      hasUnreproducibleFilters = true;
    }
    return { ...gadget, ownScope: fragment.ownScope };
  });

  return { ...view, gadgets, hasUnreproducibleFilters };
};

export default mergeScopeIntoView;
